export default {
	permissData: [],
	/* 数字格式化
	 * s => 值
	 * m => 传入步长 函数内处理步长
	 * 返回根据步长进行格式化的值
	 */
	fmoney: function(s, m) {
		if(!s && s != 0) return ''
		if(s==0||s=="0") return 0
		function initNum(val, length) {
			val = String(val).split('');
			for(let a = 0; a < length; a++) {
				if(!val[a] && val[a] != 0) {
					val[a] = '0'
				}
			}
			return val.join('')
		}
		let minus = false; //判断是否为负数
		let n = Number(m) ? String(m) : '0';
		if(n.split('.').length == 1) {
			//默认保留两位小数
			n = 2
		} else {
			//m的值示例: 0.1,0.001,0.0001 小数点后有几位  则保留几位小数
			n = n.split('.')[1].length;
		}
		n = n > 0 && n <= 20 ? n : 2;//小数点所保留的长度最高不能超过20
		if(Number(s) < 0) {
			minus = true
			s = Number(String(s).split('-')[1])
		}
		s = parseFloat((s + "").replace(/[^\d\.-]/g, "")) + "";
		s = m||m==0?(s.split('.')[0] + (s.split('.')[1] ? '.' + initNum((s.split('.')[1].substring(0, n)), n) : '.' + initNum(0, n))):s
		var l = s.split(".")[0].split("").reverse(),
			r = s.split(".")[1];
		var t = "";
		for(let i = 0; i < l.length; i++) {
			t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
		}
		r = r ? '.' + r : '';
		if(String(m).split('.').length == 1) {
			if(m||m==0){
				r = ''
			}
		}

		if(minus) {
			return '-' + t.split("").reverse().join("") + r;
		} else {
			return t.split("").reverse().join("") + r;
		}
	},
	fmoneyNoFix: function(s) {
		if(s==0||s=="0") return 0
		let minus = false; //判断是否为负数
		if(Number(s) < 0) {
			minus = true
			s = Number(String(s).split('-')[1])
		}
		s = parseFloat((s + "").replace(/[^\d\.-]/g, "")) + "";
		var l = s.split(".")[0].split("").reverse(),
			r = s.split(".")[1];
		var t = "";
		for(let i = 0; i < l.length; i++) {
			t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
		}
		r = r ? '.' + r : ''
		if(minus) {
			return '-' + t.split("").reverse().join("") + r;
		} else {
			return t.split("").reverse().join("") + r;
		}
	},
	timestampToTime: function(now) {
		if(now == "" || now == null || typeof now == 'string') {
			return
		}
		now = new Date(Number(now))
		let year = now.getFullYear(); //取得4位数的年份
		let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
		let date = now.getDate(); //返回日期月份中的天数（1到31）
		let hour = now.getHours(); //返回日期中的小时数（0到23）
		let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
		let second = now.getSeconds(); //返回日期中的秒数（0到59）
		if(month < 10) {
			month = "0" + month
		}
		if(date < 10) {
			date = "0" + date
		}
		if(hour < 10) {
			hour = "0" + hour
		}
		if(minute < 10) {
			minute = "0" + minute
		}
		if(second < 10) {
			second = "0" + second
		}
		return `${year+"-"+month+"-"+date} ${hour + ':' + minute+":"+second}`;
	},
	timestampToTimeDelYear: function(now) {
		if(now == "" || now == null || typeof now == 'string') {
			return
		}
		now = new Date(Number(now))
		let year = now.getFullYear(); //取得4位数的年份
		let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
		let date = now.getDate(); //返回日期月份中的天数（1到31）
		let hour = now.getHours(); //返回日期中的小时数（0到23）
		let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
		let second = now.getSeconds(); //返回日期中的秒数（0到59）
		if(month < 10) {
			month = "0" + month
		}
		if(date < 10) {
			date = "0" + date
		}
		if(hour < 10) {
			hour = "0" + hour
		}
		if(minute < 10) {
			minute = "0" + minute
		}
		if(second < 10) {
			second = "0" + second
		}
		return `${month+"-"+date} ${hour + ':' + minute+":"+second}`;
	},
	istrue: function(val) {
		if(val == undefined || val == "" || val == NaN || val == null) {
			return false
		} else {
			return true
		}
	},
	isPermiss: function(value) {
		var self = this;
		var permissData = localStorage.getItem("permission").split(',');
		for(var a = 0; a < permissData.length; a++) {
			if(permissData[a] == value) {
				return true;
			}
		}
	},
	remove: function(arr, val) {
		var index = arr.indexOf(val);
		if(index > -1) {
			arr.splice(index, 1);
		}
		return arr;
	},
	getTime: function() {
		var now = new Date();
		var year = now.getFullYear(); //得到年份
		var month = now.getMonth(); //得到月份
		var date = now.getDate(); //得到日期
		var day = now.getDay(); //得到周几
		var hour = now.getHours(); //得到小时
		var minu = now.getMinutes(); //得到分钟
		var sec = now.getSeconds(); //得到秒
		var MS = now.getMilliseconds(); //获取毫秒
		var week;
		month = month + 1;
		if(month < 10) month = "0" + month;
		if(date < 10) date = "0" + date;
		if(hour < 10) hour = "0" + hour;
		if(minu < 10) minu = "0" + minu;
		if(sec < 10) sec = "0" + sec;
		if(MS < 100) MS = "0" + MS;
		var arr_week = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
		week = arr_week[day];
		var time = "";
		time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
		return time;
	},
	/* 传入后台返回的数据集历史记录 返回最大值最小值
	 * result => 数据集历史记录数据
	 */
	getNum: function(result){
		let max,min;
		let arr = [];
		for(let res of result){
			arr = arr.concat(res.data)
		}
		for(var i of arr){
			for(let c of i.value){
				if(c||c==0){
					if(!max&&max!=0) max = c;
					if(!min&&min!=0) min = c;
					if(max < c) max = c;
					if(min > c) min = c;
				}
			}
		}
		return {
			max: max,
			min: min
		}
	},
	NearEnd(deg, id, url) {
		let obj = {};
		if(deg == 30) {
			obj.transform = `rotate(${-deg}deg)`;

			if(id == 0) {
				obj.right = '-16px'
				obj.top = '-18px'
			}
			if(id == 8) {
				obj.right = '-12px'
				obj.top = '-8px'
			}
			if(id == 9) {
				obj.right = '-16px'
				obj.top = '-11px'
			}
			if(id == 14) {
				obj.right = '-11px'
				obj.top = '-13px'
			}
			if(id == 22) {
				obj.right = '-15px'
				obj.top = '-8px'
			}
			if(id == 23) {
				obj.right = '-9px'
				obj.top = '-18px'
			}
		} else if(deg == 90) {

			if(id == 10) {
				obj.bottom = '-16px'
				obj.left = '-7px'
			}
			if(id == 15) {
				obj.bottom = '-16px'
				obj.left = '-20px'
			}
			if(id == 16) {
				obj.bottom = '-10px'
				obj.left = '-7px'
			}
			if(id == 17) {
				obj.bottom = '-15px'
				obj.left = '-13px'
			}
			if(id == 20) {
				obj.bottom = '-14px'
				obj.left = '-13px'
			}
			if(id == 23) {
				obj.bottom = '-10px'
				obj.left = '-20px'
			}
      if(id==24){
        obj.top = '-8.5px'
        obj.left = '-15px'
      }
      if(id==27){
        obj.left = '-15px'
        obj.top = '-20.5px'
      }
      if(id==29){
        obj.left = '-15px'
        obj.top = '-21.5px'
      }
      if(id==30){
        obj.left = '-15px'
        obj.top = '-14.5px'
      }
      if(id==31){
        obj.left = '-20px'
        obj.top = '-8.5px'
      }
		} else if(deg == -30) {
			obj.transform = `rotate(${-deg}deg)`;

			if(id == 0) {
				obj.left = '-15px'
				obj.top = '-18px'
			}
			if(id == 3) {
				obj.left = '-15px'
				obj.top = '-8px'
			}
			if(id == 6) {
				obj.left = '-11px'
				obj.top = '-9px'
			}
			if(id == 7) {
				obj.left = '-14px'
				obj.top = '-12px'
			}
			if(id == 11) {
				obj.left = '-12px'
				obj.top = '-12px'
			}
			if(id == 16) {
				obj.left = '-9px'
				obj.top = '-17px'
			}
		}else if(deg == 0) {
			obj.transform = `rotate(${-deg}deg)`;

			if(id == 25) {
				obj.right = '-16px'
				obj.top = '-7.5px'
			}
      if(id == 26) {
      	obj.right = '-16px'
      	obj.top = '-21.5px'
      }
      if(id == 28) {
      	obj.right = '-16px'
      	obj.top = '-15.5px'
      }
      if(id == 29) {
      	obj.right = '-16px'
      	obj.top = '-21.5px'
      }
      if(id == 31) {
      	obj.right = '-16px'
      	obj.top = '-7.5px'
      }
		}
		obj['background-image'] = 'url('+url+')'
		if(!url){
			return {}
		}
		let imgGo = new Image();
		imgGo.src = url;
		obj.width = imgGo.naturalWidth + 'px'
		obj.height = imgGo.naturalHeight + 'px'
		return obj
	},
  // 2d
  NearEnd_2d(deg, id, url) {
  	let obj = {};
  	if(deg == 90) {
      if(id==26){
        obj.left = '-20.5px'
        obj.bottom = '-13px'
      }
      if(id==27){
        obj.left = '-7px'
        obj.bottom = '-14px'
      }
      if(id==28){
        obj.left = '-20.5px'
        obj.bottom = '-18px'
      }
      if(id==29){
        obj.left = '-14px'
        obj.bottom = '-14px'
      }
      if(id==30){
        obj.left = '-8px'
        obj.bottom = '-17px'
      }
  	}else if(deg == 0) {
  		if(id == 24) {
  			obj.left = '-16px'
  			obj.top = '-7px'
  		}
      if(id == 27||id == 29) {
  			obj.left = '-16px'
  			obj.top = '-21px'
      }
      if(id == 30) {
      	obj.left = '-16px'
      	obj.top = '-14px'
      }
      if(id == 31) {
      	obj.left = '-16px'
      	obj.top = '-7.5px'
      }
  	}
  	obj['background-image'] = 'url('+url+')'
  	if(!url){
  		return {}
  	}
  	let imgGo = new Image();
  	imgGo.src = url;
  	obj.width = imgGo.naturalWidth + 'px'
  	obj.height = imgGo.naturalHeight + 'px'
  	return obj
  },
	FarEnd(deg, id, url) {
		let obj = {};
		if(deg == 30) {
			obj.transform = `rotate(${-deg}deg)`;

			if(id == 4) {
				obj.left = '-15px'
				obj.top = '-10px'
			}
			if(id == 6) {
				obj.left = '-9px'
				obj.top = '-17px'
			}
			if(id == 10) {
				obj.left = '-13px'
				obj.top = '-19px'
			}
			if(id == 12) {
				obj.left = '-11px'
				obj.top = '-16px'
			}
			if(id == 18) {
				obj.left = '-13px'
				obj.top = '-15px'
			}
			if(id == 19) {
				obj.left = '-7px'
				obj.top = '-11px'
			}
		} else if(deg == 90) {
			if(id == 2) {
				obj.top = '-10px'
				obj.right = '-7px'
			}
			if(id == 3) {
				obj.top = '-14px'
				obj.right = '-20px'
			}
			if(id == 5) {
				obj.top = '-13px'
				obj.right = '-11px'
			}
			if(id == 19) {
				obj.top = '-10px'
				obj.right = '-21px'
			}
			if(id == 21) {
				obj.top = '-13px'
				obj.right = '-17px'
			}
			if(id == 22) {
				obj.top = '-14px'
				obj.right = '-9px'
			}

		} else if(deg == -30) {
			obj.transform = `rotate(${-deg}deg)`;

			if(id == 1) {
				obj.right = '-16px'
				obj.top = '-13px'
			}
			if(id == 2) {
				obj.right = '-9px'
				obj.top = '-11px'
			}
			if(id == 4) {
				obj.right = '-15px'
				obj.top = '-10px'
			}
			if(id == 8) {
				obj.right = '-9px'
				obj.top = '-17px'
			}
			if(id == 13) {
				obj.right = '-12px'
				obj.top = '-16px'
			}
			if(id == 15) {
				obj.right = '-13px'
				obj.top = '-19px'
			}
		}
		obj['background-image'] = 'url('+url+')'
		if(!url){
			return {}
		}
		let imgGo = new Image();
		imgGo.src = url;
		obj.width = imgGo.naturalWidth + 'px'
		obj.height = imgGo.naturalHeight + 'px'
		return obj
	},
  FarEnd_2d(deg, id, url) {
  	let obj = {};
  	if(deg == 90) {
  		if(id == 24) {
  			obj.top = '-16px'
  			obj.left = '-8px'
  		}
  		if(id == 25||id == 28) {
  			obj.top = '-16px'
  			obj.left = '-21px'
  		}
  		if(id == 30) {
  			obj.top = '-16px'
  			obj.left = '-7px'
  		}
  		if(id == 31) {
  			obj.top = '-16px'
  			obj.left = '-14px'
  		}

  	} else if(deg == 0) {
  		if(id == 25) {
  			obj.right = '-16px'
  			obj.top = '-8px'
  		}
  		if(id == 26) {
  			obj.right = '-16px'
  			obj.top = '-21px'
  		}
  		if(id == 28) {
  			obj.right = '-16px'
  			obj.top = '-14px'
  		}
  		if(id == 29) {
  			obj.right = '-21px'
  			obj.top = '-21px'
  		}
  		if(id == 31) {
  			obj.right = '-21px'
  			obj.top = '-8px'
  		}
  	}
  	obj['background-image'] = 'url('+url+')'
  	if(!url){
  		return {}
  	}
  	let imgGo = new Image();
  	imgGo.src = url;
  	obj.width = imgGo.naturalWidth + 'px'
  	obj.height = imgGo.naturalHeight + 'px'
  	return obj
  },
  arrayToTree(arr,childrenKey) {
    // 定义目标数组
    let obj = []
    if(!childrenKey){
      childrenKey = 'child'
    }
    // 循环原始数据
    for (let i in arr) {
      // 如果当前索引值的pid为空，那么就代表当前的索引值为“根级”数据，那么直接push到目标数组里
      if (!arr[i].parentId) {
        obj.push(arr[i])
      } else {
        /**
         * 当前索引值的parentId不为空时，
         * 因为当前的parentId就相当于当前元素上一级的id
         * 所以要找到原始数据中 哪个item的id等于当前的parentId，
         * 假设我们找到的元素叫item，那么item就是当前索引值的父级
         * 所以item.child 就等于当前的索引值。
         * 当我们在原始数据中心找到对应的item，为其设置了child后
         * 目标数组obj中对应的item也会同时修改，因为JS中对象的为引用类型，一个地方修改，所有引用的地方都修改
         */
        let item = arr.find(element => element.id === arr[i].parentId)
        if(item){
          if(item[childrenKey]){
            item[childrenKey].push(arr[i])
          }else{
            item[childrenKey]=[arr[i]]
          }
        }
      }
    }
    return obj
  }
}



// WEBPACK FOOTER //
// ./src/components/MapEditor/Config/common.js